"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ic_border_color = exports.ic_border_color = { "viewBox": "0 0 24 24", "children": [{ "name": "path", "attribs": { "d": "M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29c-.39-.39-1.02-.39-1.41 0L15 2.25 18.75 6l1.96-1.96z" } }, { "name": "path", "attribs": { "fill-opacity": ".36", "d": "M0 20h24v4H0z" } }] };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/md/ic_border_color.js
// module id = 2024
// module chunks = 0